<div
    #container
    *ngIf="isEditing"
    class="agpr-numberInput"
    [class.agpr-numberInput--spaced]="bottomMargin"
>

    <!-- If we're using a separate label outside this component, we need to set it as ariaLabelledBy so that it meets accessbility requirements -->

    <div
        *ngIf="label || required"
        class="agpr-numberInput-label"
        [attr.aria-labelledby]="ariaLabelledBy"
        >
        {{ label | localize }}
        <span *ngIf="required" class="agpr-numberInput-required">*</span>
        <span
            *ngIf="tooltip"
            role="img"
            class="agpr-numberInput-tooltip fa-regular fa-circle-info"
            [agprTooltip]="tooltip"
        ></span>
    </div>
    <i
        *ngIf="labelIcon"
        [class]="labelIcon + ' agpr-numberInput-labelIcon'"
    >
    </i>
    <div class="agpr-numberInput-container">
        <div class="agpr-numberInput-inputWrapper">
            <input
                #input
                [id]="id"
                type="number"
                [placeholder]="placeholder | localize"
                class="agpr-numberInput-input"
                [class.agpr-numberInput-input--withIcon]="icon"
                [class.agpr-numberInput-input--withUnit]="unit"
                [min]="min"
                [max]="max"
                [step]="step"
                [disabled]="disabled"
                [(ngModel)]="value"
                (ngModelChange)="computeChanges(true)"
                (blur)="onBlur($event)"
                (focus)="onFocus($event)"
                (keydown)="onKeydown($event)"
                [attr.aria-describedby]="ariaDescribedBy"
            />
            <div *ngIf="showArrows" class="agpr-numberInput-arrows" [ngClass]="{'agpr-numberInput-arrows--disabled': disabled}">
                <button
                    type="button"
                    [disabled]="disabled"
                    (mousedown)="preventArrowFocus($event)"
                    (click)="upArrowClick()"
                    [attr.aria-label]="'Common.filter.range.add' | localize"
                    tabindex="-1"
                >
                    <span class="fa-solid fa-angle-up"></span>
                </button>
                <button
                    type="button"
                    [disabled]="disabled"
                    (mousedown)="preventArrowFocus($event)"
                    (click)="downArrowClick()"
                    [attr.aria-label]="'Common.filter.range.reduce' | localize"
                    tabindex="-1"
                >
                    <span class="fa-solid fa-angle-down"></span>
                </button>
            </div>
            <span
                *ngIf="icon"
                class="agpr-numberInput-icon"
                [ngClass]="icon"
            ></span>
            <span
                *ngIf="unit && value"
                class="agpr-numberInput-unit"
                [ngStyle]="{ 'left': useRemUnit ? (remOffset/16) + 'rem' : unitOffset + 'px' }"
            >
                {{ unit }}
            </span>
        </div>
    </div>
</div>
